import { render } from "./delivery-mode.vue?vue&type=template&id=32532fd1&ts=true"
import script from "./delivery-mode.ts?vue&type=script&lang=ts&external"
export * from "./delivery-mode.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__